// extracted by mini-css-extract-plugin
export var chip = "_38-0";
export var filterDropdown = "_38-5";
export var filterItem = "_38-6";
export var icon = "_38-1";
export var removeButton = "_38-3";
export var removeIcon = "_38-4";
export var separator = "_38-2";